export const LIST_STORE = 'LIST_STORE';
export const DELETE_STORES = 'DELETE_STORES';
export const DELETE_STORE = 'DELETE_STORE';
export const CREATE_STORE = 'CREATE_STORE';
export const UPDATE_STORE = 'UPDATE_STORE';
export const UPGRADE_STORE = 'UPGRADE_STORE';